export const MINDMAP_VERSION = 1;
export const MINDMAP_SEED_ID = 'mindmap-showcase';
export const MINDMAP_ROOT_NODE_ID = 'mindmap-root';
export const MINDMAP_ROOT_LABEL = 'Mindmap';
